<template>
    <div class="language-switch">
        <img class="language-switch__flag-icon language-switch__flag-icon--squared" :src="`/images/flags/${getCurrentLangCode()}.svg`" />
        <div class="language-switch__select">
            <div class="language-switch__header">{{trans('language_select.select_language')}}</div>
            <form :action="route('change.language')" method="post" :class="['language-switch__language', {'language-switch__language--current': lang.code == language}]" v-for="lang in languages" v-bind:key="lang.code" @click="changeLanguage">
                <csrf-field></csrf-field>
                <input type="hidden" name="lang" :value="lang.code" />
                <img class="language-switch__flag-icon language-switch__flag-icon--squared language-switch__flag-icon--margin-right" :src="`/images/flags/${lang.flag}.svg`" />
                {{ trans('language_select.languages.' + lang.code) }}
            </form>
        </div>
    </div>
</template>

<script>
export default {
    name: "LanguageSwitch",

    data() {
        return {
            languages: [
                {
                    name: 'Deutsch',
                    code: 'de',
                    flag: 'de'
                },
                {
                    name: 'Englisch',
                    code: 'en',
                    flag: 'gb'
                },
                {
                    name: 'Spanisch',
                    code: 'es',
                    flag: 'es'
                },
                {
                    name: 'Französisch',
                    code: 'fr',
                    flag: 'fr'
                }
            ]
        }
    },

    props: ['language'],

    methods: {
        changeLanguage(event) {
            event.target.submit();
        },

        getCurrentLangCode() {
            return this.languages.filter(language => {
                return language.code == this.language;
            })[0].flag;
        },
    },
}
</script>
